import { Validators } from "@angular/forms";
import { IFormKey } from "src/app/modules/shared/models/forms";

export const bank_account_update_form_template = {
    iban: ''
}

export const bank_account_update_form_validators = {
  iban: [Validators.required]
}

export const bank_account_update_form_keys: IFormKey[] = [
  {
    id: 'iban-field',
    label: 'Coordinate bancarie',
    controlName: 'iban',
    css: 'col-6',
    type: 'SELECT'
  }
];

export interface IVariazioneModPagamentoRequest {
  policyNumber: string;
  iban: string;
  accountHolder: string;
  numeroRapporto: string;
}
